import type { Transition, Variants } from 'framer-motion';

/** Spring configs by interaction class — physics, not eased tweens. */
export const spring: Record<'snappy' | 'bouncy' | 'smooth' | 'heavy', Transition> = {
  snappy: { type: 'spring', stiffness: 500, damping: 30, mass: 0.8 },
  bouncy: { type: 'spring', stiffness: 400, damping: 20, mass: 1 },
  smooth: { type: 'spring', stiffness: 260, damping: 26, mass: 1 },
  heavy: { type: 'spring', stiffness: 200, damping: 30, mass: 1.4 },
};

export const viewportOnce = { once: true, margin: '-12% 0px' } as const;

export function staggerContainer(step = 0.06, delay = 0.06): Variants {
  return {
    hidden: {},
    show: { transition: { staggerChildren: step, delayChildren: delay } },
  };
}

export function riseItem(reduce: boolean | null, travel = 20): Variants {
  if (reduce) {
    return {
      hidden: { opacity: 0 },
      show: { opacity: 1, transition: { duration: 0.15, ease: 'easeOut' } },
    };
  }
  return {
    hidden: { opacity: 0, y: travel },
    show: { opacity: 1, y: 0, transition: spring.smooth },
  };
}

export function popItem(reduce: boolean | null): Variants {
  if (reduce) {
    return {
      hidden: { opacity: 0 },
      show: { opacity: 1, transition: { duration: 0.15, ease: 'easeOut' } },
    };
  }
  return {
    hidden: { opacity: 0, scale: 0.96 },
    show: { opacity: 1, scale: 1, transition: spring.bouncy },
  };
}

export function pressProps(reduce: boolean | null) {
  if (reduce) return {};
  return {
    whileHover: { scale: 1.03 },
    whileTap: { scale: 0.96 },
    transition: spring.snappy,
  };
}
